<div class="flex">
  <div *ngFor="let color of colors">
    <tsq-color-picker-item [color]="color" (colorChange)="onColorSelected($event)"></tsq-color-picker-item>
  </div>
</div>

